import {
  Directive,
  ElementRef,
  HostListener,
  AfterViewChecked,
  OnInit,
  AfterViewInit
} from "@angular/core";
import { NgControl } from "@angular/forms";
declare var $: any;

@Directive({
  selector: "[FlowUpLabel]"
})
export class FlowUpLabelDirective implements AfterViewInit {
  settings = {
    feature_onLoadInit: true,
    class_focused: "focused",
    class_populated: "populated"
  };
  constructor(private el: ElementRef, private control: NgControl) {
    // debugger;
  }

  ngAfterViewInit() {
    // console.log('FlowUpLabelDirective - ngAfterViewInit', this.el)
    this.handleBlur();
  }

  @HostListener("focus", ["$event"])
  handleFocus(event?: Event) {
    $(this.el.nativeElement)
      .closest(".fl_wrap")
      .addClass(this.settings.class_focused);
  }

  @HostListener("blur", ["$event"])
  handleBlur(event?: Event) {
    var $this = $(this.el.nativeElement);
    if ($this.val() != null && $this.val().length) {
      $this
        .closest(".fl_wrap")
        .addClass(this.settings.class_populated)
        .removeClass(this.settings.class_focused);
    } else {
      $this
        .closest(".fl_wrap")
        .removeClass(this.settings.class_populated)
						.removeClass(this.settings.class_focused);
    }
  }
}
